import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import copy from '../helpers/copyToClipboard';
import buildText from '../helpers/mailStaticTemplate';

import { getProposedChanges, showOnlyAll } from '../helpers/constitutionResults';
import { ConstitutionVoteApi } from '../../../api/ConstitutionVote';
import { getTokenStatus, getUserData, getPollResultsAllChoice } from '../../../shared/redux/selectors';

import Section from '../../../shared/components/Section';
import SectionTitle from '../../../shared/components/SectionTitle';
import TwoCols from '../../../shared/structure/TwoCols';
import VoteResultsTabs from './VoteResultsTabs';
import SendByUsualMail from '../components/email/SendByUsualMail';
import SendByEmail from '../components/email/SendByEmail';

function ResultsEmailContainer({ userData, allResults }) {
  const { t, i18n } = useTranslation();
  const selectedLanguage = i18n.language || window.localStorage.i18nextLng;
  const [copyEmailLoading, setCopyEmailLoading] = useState(false);
  const [copyMailTextLoaded, setCopyMailTextLoaded] = useState(false);
  const [copyMailTextLoading, setCopyMailTextLoading] = useState(false);
  const [copyUsualMailLoading, setCopyUsualMailLoading] = useState(false);
  const [emailLinkText, setEmailLinkText] = useState('');
  const [printLoading, setPrintLoading] = useState(false);
  const [state, setState] = useState('all');
  const [usualLinkText, setUsualLinkText] = useState('');
  const [link, setLink] = useState('');

  const printRef = useRef(null);

  const handleStateChange = (id) => () => setState(id);

  const isOnlyAll = showOnlyAll(userData);

  const body = {
    personalChoice: state === 'my',
    lang: selectedLanguage.toUpperCase(),
  };

  function getEmailTemplateLink() {
    return ConstitutionVoteApi.getEmailLink(body)
      .then((data) => data)
      .catch(() => {
        // do nothing
      });
  }

  useEffect(() => {
    getEmailTemplateLink().then((data) => {
      setLink(data);
    });
  });

  async function printEmail(event) {
    setPrintLoading(true);
    if (printRef.current.href.indexOf('null') > 0) {
      event.preventDefault();
    }
    let emailTemplateLink = await getEmailTemplateLink();
    if (emailTemplateLink) {
      emailTemplateLink += '&print=1';
      printRef.current.href = emailTemplateLink;
      setPrintLoading(false);
      printRef.current.click();
    }
  }

  async function copyUsualMailLink() {
    setCopyUsualMailLoading(true);
    try {
      copy(link);
      setUsualLinkText(link);
      setCopyUsualMailLoading(false);
    } catch (e) {
      // do nothing
    }
  }

  function copyEMailText() {
    setCopyMailTextLoading(true);
    try {
      const proposedChanges = getProposedChanges(body.personalChoice ? userData : allResults);
      const text = buildText(proposedChanges, selectedLanguage.toUpperCase());
      copy(text);
      setCopyMailTextLoading(false);
      setCopyMailTextLoaded(true);
    } catch (e) {
      // do nothing
    }
  }

  function copyEMailLink() {
    setCopyEmailLoading(true);
    try {
      copy(link);
      setEmailLinkText(link);
      setCopyEmailLoading(false);
    } catch (e) {
      // do nothing
    }
  }

  return (
    <>
      <Section
        background="blue"
        title={isOnlyAll ? t('mail_nochoose_mail_option') : ''}
        content={(
          <>
            {!isOnlyAll && (
              <TwoCols
                rightAlign="right"
                justifyContent="center"
                left={(
                  <SectionTitle title={t('mail_choose_mail_option')} />
                )}
                right={(
                  <VoteResultsTabs
                    selected={state}
                    onChange={handleStateChange}
                  />
                )}
              />
            )}
          </>
        )}
      />

      <Section
        background="gray"
        title={t('mail_choose_medium')}
      />

      <Section
        content={(
          <>
            <SendByUsualMail
              copyLink={copyUsualMailLink}
              copyLinkText={usualLinkText}
              handlePrint={printEmail}
              isCopyLoading={copyUsualMailLoading}
              isPrintLoading={printLoading}
              printLink="null"
              printRef={printRef}
            />

            <SendByEmail
              copyLink={copyEMailLink}
              copyLinkText={emailLinkText}
              copyEMailText={copyEMailText}
              link={link}
              isCopyLoading={copyEmailLoading}
              isCopyMailTextLoaded={copyMailTextLoaded}
              isCopyMailTextLoading={copyMailTextLoading}
              state={state}
            />
          </>
        )}
      />
    </>
  );
}

ResultsEmailContainer.defaultProps = {
  userData: null,
};

ResultsEmailContainer.propTypes = {
  userData: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = (state) => ({
  userData: getUserData(state),
  allResults: getPollResultsAllChoice(state),
  tokenStatus: getTokenStatus(state),
});

export default connect(mapStateToProps)(ResultsEmailContainer);
